import { attioSchema, FivetranServiceEnum } from "@repo/fivetran/types";

import {
  DestinationField,
  DestinationSetupField,
  SchemaField,
} from "./connection-fields";
import { ConnectionFormShell } from "./connection-form-shell";
import {
  type ConnectionFormProps,
  useConnectionForm,
} from "./use-connection-form";

export const AttioFormPage = ({
  onConnected,
  onCancel,
}: ConnectionFormProps = {}) => {
  const { form, embedded, formId } = useConnectionForm({
    service: FivetranServiceEnum.enum.attio,
    schema: attioSchema,
    defaultConfig: { schema: FivetranServiceEnum.enum.attio },
    onConnected,
  });

  return (
    <ConnectionFormShell
      form={form}
      formId={formId}
      icon="attio"
      submitLabel="Authenticate"
      embedded={embedded}
      onCancel={onCancel}
    >
      <DestinationField form={form} />
      <DestinationSetupField form={form} />
      <SchemaField form={form} />
    </ConnectionFormShell>
  );
};
